import React from "react";
import { IconButton, Tooltip } from "@chakra-ui/react";
import { colours } from "@/theme/colours";
import { ChakraFAIcon } from "../ui/Icon";

interface Props {
	iconName: string;
	label: string;
	onClick: () => void;
	isDisabled?: boolean;
}

export function OptionButton(props: Props): JSX.Element {
	return (
		<Tooltip label={props.label} placement="top" hasArrow>
			<IconButton
				size={"sm"}
				background={"white"}
				shadow={"sm"}
				color={colours.neutrals[300]}
				_hover={{
					background: colours.neutrals[15],
				}}
				p={2}
				onClick={props.onClick}
				aria-label={props.label}
				icon={<ChakraFAIcon icon={props.iconName} variant="solid" />}
				isDisabled={props.isDisabled}
			/>
		</Tooltip>
	);
}
